'use client';

import { RaffleCard } from '@/components';
import type { Raffle } from '@/types/models/Raffle';

import { CarouselDots, ResultsCarouselNavigation } from './components';
import { useResultsCarousel } from './hooks';

type FinishedResultsSectionProps = {
  raffles: Raffle[];
  'data-cy'?: string;
};

export const FinishedResultsSection = ({
  raffles,
  ...props
}: FinishedResultsSectionProps) => {
  const {
    emblaRef,
    showControls,
    selectedIndex,
    snapCount,
    canScrollPrev,
    canScrollNext,
    scrollPrev,
    scrollNext,
  } = useResultsCarousel({ totalSlides: raffles?.length ?? 0 });

  if (!raffles || raffles.length === 0) return null;

  const dataCy = props['data-cy'] || 'main-content-finished-raffles';

  return (
    <div className="space-y-2" data-cy={dataCy}>
      <h1
        data-cy="main-content-finished-raffles-title"
        className="text-2xl font-bold text-foreground"
      >
        Últimos Resultados
      </h1>

      <div className="relative">
        <div
          ref={emblaRef}
          className="overflow-hidden"
          data-cy="main-content-finished-raffles-carousel"
        >
          <div className="flex -ml-4 touch-pan-y">
            {raffles.map((raffle) => (
              <div
                key={raffle.id}
                className="min-w-0 shrink-0 grow-0 basis-full md:basis-1/2 lg:basis-1/3 pl-4"
              >
                <RaffleCard raffle={raffle} />
              </div>
            ))}
          </div>
        </div>

        {showControls && (
          <ResultsCarouselNavigation
            data-cy={dataCy}
            onPrev={scrollPrev}
            onNext={scrollNext}
            canScrollPrev={canScrollPrev}
            canScrollNext={canScrollNext}
          />
        )}
      </div>

      {showControls && (
        <CarouselDots data-cy={dataCy} total={snapCount} selectedIndex={selectedIndex} />
      )}
    </div>
  );
};
